export const getVisibleCapabilities = (capabilities = []) => capabilities
  .filter((capability) => !capability.ui_hidden && !capability.legacy)
  .sort((a, b) => {
    const moduleOrder = (a.module_order ?? 9999) - (b.module_order ?? 9999);
    if (moduleOrder !== 0) return moduleOrder;
    if (!!a.is_module_access !== !!b.is_module_access) return a.is_module_access ? -1 : 1;
    return String(a.label || a.key).localeCompare(String(b.label || b.key), 'nl');
  });

export const groupCapabilitiesByModule = (capabilities = []) => {
  const groups = new Map();

  getVisibleCapabilities(capabilities).forEach((capability) => {
    const moduleKey = capability.module || 'overig';
    if (!groups.has(moduleKey)) {
      groups.set(moduleKey, {
        module: moduleKey,
        label: capability.module_label || 'Overig',
        order: capability.module_order ?? 9999,
        capabilities: [],
      });
    }
    groups.get(moduleKey).capabilities.push(capability);
  });

  return Array.from(groups.values()).sort((a, b) => a.order - b.order || a.label.localeCompare(b.label, 'nl'));
};

export const roleCapabilityLabels = (capabilities = [], roleValue) => getVisibleCapabilities(capabilities)
  .filter((capability) => (capability.default_roles || []).includes(roleValue))
  .map((capability) => `${capability.module_label || capability.module || 'Overig'} — ${capability.label}`);

export const roleCapabilityModuleLabels = (capabilities = [], roleValue) => Array.from(new Set(
  [...capabilities]
    .sort((a, b) => (a.module_order ?? 9999) - (b.module_order ?? 9999))
    .filter((capability) => (capability.default_roles || []).includes(roleValue))
    .map((capability) => capability.module_label || capability.module || 'Overig'),
));
